const { scores, weights } = require('../config')
const createCourses = require('./courses')
const _ = require('morphable')

module.exports = createSemesters

function createSemesters(initSemesters=[]) {
  const state = _({
      semesters: [],
      newSemester (id, name, courses) {
        id = id || (Math.random()).toString(36).slice(-5)
        name = name || `Semester ${state.semesters.length+1}`
        const semester = createCourses(courses)
        Object.assign(semester, { id, name, remove: () => {
          if (state.semesters.length == 1) {
            state.newSemester(null, 'Semester 1')
          }
          rm(state.semesters, id)
        }})
        state.semesters.push(semester)
      },
      get weightedPoints () {
        return state.semesters.reduce((prev, next) => prev + next.weightedPoints, 0)
      },
      get unweightedPoints () {
        return state.semesters.reduce((prev, next) => prev + next.unweightedPoints, 0)
      },
      get credits () {
        return state.semesters.reduce((prev, next) => prev + next.credits, 0)
      },
      get gpa () {
        return state.weightedPoints / state.credits
      },
      get unweighted () {
        return state.unweightedPoints / state.credits
      }
  })

  initSemesters.forEach(({ id, name, courses }) => state.newSemester(id, name, courses))

  if (initSemesters.length == 0) {
    state.newSemester()
  }

  return state
}

function rm (arr, id) {
  arr.splice(arr.map(item => item.id).indexOf(id), 1)
}

// function focusOnNewSemester () {
//   var courses = document.getElementsByClassName('course-name')
//   var input = courses[courses.length-1].getElementsByTagName('input')[0]
//   input.focus()
// }
